<script>
import Title from '@components/section-title'
import store from '@state/store'
import con from '@services/connection'
import Vue from 'vue'
import { MODAL } from '@constants/Text'
import { GlobalBus } from '@services/bus'

export default {
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      isWhitelabel: WHITELABEL,
      stepTour: 1,
      imagensTour: [
        'https://aawz-onboarding.s3.us-east-2.amazonaws.com/web/gif-servico.gif',
        'https://aawz-onboarding.s3.us-east-2.amazonaws.com/web/gif-clientes.gif',
        this.$canSendLinks &&
          'https://aawz-onboarding.s3.us-east-2.amazonaws.com/web/gif-link.gif',
      ],
      textosTour: [
        ' Se plugue ao seu cliente e automatize sua cobrança e gestão de inadimplentes.',
        ' Envie link dos serviços para ele se cadastrar e você acompanhar a carteira dele (100% do share)',
        this.$canSendLinks &&
          ' Envie o link para que seu cliente receba um e-mail de convite para cadastro e adesão do seu serviço. Se tiver cobrança nós cuidamos do processamento e recorrência.',
      ],
      negritosTour: [
        'Cadastre serviços ',
        'Cadastre clientes ',
        this.$canSendLinks && 'Enviar link ',
      ],
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    if (this.bus) {
      this.bus.$on(MODAL.TOUR_TEMPORARIO, (v) => {
        this.busModal.$emit('dialog', v)
      })
    }
  },
  methods: {
    sendToFaq(close) {
      this.$router.push({
        name: 'suporte.faq',
      })
      close()
    },
  },
}
</script>

<template>
  <BaseModal max-width="60%" heigth="800px" :bus="busModal" persistent>
    <Title title="Boas vindas" subtitle="Primeiros passos" />
    <div>
      <div
        class="text-center"
        style="margin-bottom: 20px; align-items: center; justify-content: center"
      >
        <p class="text-bold" style="margin-bottom: 20px">{{
          negritosTour[stepTour - 1]
        }}</p>
        <p class="text-secondary">
          {{ textosTour[stepTour - 1] }}
        </p>
      </div>
      <v-img
        :src="imagensTour[stepTour - 1]"
        :lazy-src="imagensTour[stepTour - 1]"
        aspect-ratio="1"
        contain
        height="300"
        class="p-0 border"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </div>
    <div class="text-center" style="margin: 20px">
      <v-pagination
        v-model="stepTour"
        :length="imagensTour.length"
      ></v-pagination>
    </div>
    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="sendToFaq(close)">
        Quero saber mais
      </BaseButton>
      <BaseButton primary @click="close">
        Ok
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>


